import React from 'react'
import { useProvidentNomination } from '../../Hooks/Features/WelcomeKit/useProvidentNomination';
import FormTable from './FormTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dateConvert, RenderSignatureField } from '../../utils/Helper';
import { useCommanKit } from '../../Hooks/Features/WelcomeKit/useCommanKit';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';

const GratuityNomination = ({ label, onPrev, onNext, data, readOnly }) => {
    const { fieldData, formValues, nomineeTable, handleDelete, callAPI, showPopup, setShowPopup, familyData } = useProvidentNomination({ label, onNext, data });
    const { signature, handleChange, handleRemove } = useCommanKit({ data });

    return (
        <div className='my-2'>
            <div className='pb-2'>
                <div>
                    <h4 className="p-2" style={{ background: "#f2f2f2" }}>Gratuity Nomination</h4>
                </div>
                <div className='text-center my-4'>
                    <h5 style={{ fontSize: "14px", fontWeight: "700" }} >FORM 'F' </h5>
                    <h5 style={{ fontSize: "14px", fontWeight: "700" }} >[See Sub rule (I) of rule 6]</h5>
                    <h5 style={{ fontSize: "14px", fontWeight: "700" }} >NOMINATION</h5>
                </div>
                <div>
                    <p className='my-2'>To</p>
                    <p className='my-1'>I, Shri/Shrimati/Kumari  <strong>{data?.employee?.user_display_name}</strong></p>
                    <p className='my-1'>1. Whose particulars are given in the statement below, hereby nominate the person(s) mentioned below to receive the gratuity payable after my death as also the gratuity standing to my credit in the of my death before that has become payable, or having become payable has not been paid and direct that the said amount of gratuity shall be paid in proportion indicated against the name(s) of the nominee(s).</p>
                    <p className='my-1'>2. I, hereby certify that the person(s) nominated is a/are member(s) of my family within the meaning of Clause (h) of section 2 of the payment of Gratuity Act, 1972.</p>
                    <p className='my-1'>3. I, hereby declare that I have no family within the meaning of clause (h) of section 2 of the said Act.</p>
                    <p>4.<span>(a) My father/Mother/Parents is/ are dependent on me.</span>
                        <p>(b) My husband's/wife's father/Mother/Parents is/ are not dependent on my husband/wife.</p>
                    </p>
                    <p className='my-1'>5. I have excluded my husband/wife from my family by a notice dated the ................... to the controlling authority in terms of the proviso to clause (h) of section 2 of the said Act.</p>
                    <p className='my-1'>6. Nomination made herein invalidates my previous nomination.</p>
                </div>
                {Object.entries(fieldData).map(([section, fields]) => {
                    if (fields?.key === "employee_common_details") {
                        return <table className="table table-bordered my-5">
                            <tbody>
                                {
                                    formValues[fields?.key]?.length > 0 && fields?.inputs?.map((value, index) => {
                                        return <tr key={index}>
                                            <th className='w5 text-center'>{index + 1}</th>
                                            <th className='w25'>{value?.label}</th>
                                            <td>{value?.type === "date" ? dateConvert(formValues[fields?.key]?.[0]?.[value?.name], "day-mon-year") : formValues[fields?.key]?.[0]?.[value?.name]}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    }
                    return <>
                        <div className='my-5'>
                            <h5 className='text-center bold'>{section}</h5>
                            <FormTable onPrev={onPrev} onNext={onNext} label={label} fieldsDetails={{ [section]: fields }} data={data} IsTitle={"no"} notTable={fields?.key === "employee_gratuity_nominee"} handleAPI={callAPI} row={formValues} familyList={familyData} readOnly={readOnly} />
                            {
                                fields?.key === "employee_gratuity_nominee" && <div>
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Relationship with the employee</th>
                                                <th>Age</th>
                                                <th>Proportion by which the gratuity will be shared (%)</th>
                                                <th>Whether residing with him/her</th>
                                                <th colSpan={2}>If 'No' state Place of Residence</th>
                                                {
                                                    !readOnly && <th>Action</th>
                                                }
                                            </tr>
                                            <tr>
                                                <th colSpan={5}></th>
                                                <th colSpan={1}>Town</th>
                                                <th colSpan={1}>State</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formValues[section]?.map((nominee, index) => {
                                                return <tr key={index}>
                                                    <td>{nominee?.member_name}</td>
                                                    <td>{nominee?.relationship}</td>
                                                    <td>{nominee.nominee_percentage}</td>
                                                    <td>
                                                        {nominee.minor === 'Yes'
                                                            ? (
                                                                <>
                                                                    <div>Name: {nominee?.gardian_name}</div>
                                                                    <div>Relationship: {nominee?.guardianRelationship}</div>
                                                                    <div>Address: {nominee?.gardian_address_data}</div>
                                                                </>
                                                            )
                                                            : 'N/A'}
                                                    </td>
                                                    <td>{nominee?.is_residing_with_relative}</td>
                                                    <td>{nominee?.is_residing_with_relative ? nominee?.residence_town || 'Not provided' : 'N/A'}</td>
                                                    <td>{nominee?.is_residing_with_relative ? nominee?.residence_town || 'Not provided' : 'N/A'}</td>
                                                    {
                                                        !readOnly && <td>  <FontAwesomeIcon
                                                            icon="fa-solid fa-trash"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => setShowPopup({ visibel: true, section, row: nominee })}
                                                        /> </td>
                                                    }
                                                </tr>
                                            })}
                                            <tr>
                                                <td colSpan="3" style={{ fontWeight: 'bold', textAlign: 'right' }}></td>
                                                <td colSpan="5" style={{ fontWeight: 'bold' }}>{nomineeTable(formValues[section]) || 0} %</td>
                                            </tr>
                                        </tbody>
                                    </table>


                                </div>
                            }
                        </div>

                    </>
                }
                )}

                <div className='border-bottom border-top py-4 px-2 d-flex justify-content-between'>
                    <div>
                        <p>Certificate by the employer</p>
                        <p>Certified that the particulars of the above nomination have been verified and recorded in the establishment.</p>
                        <p>Employer’s Reference No., if any.....................</p>
                    </div>
                    <div>
                        <p>  Group Head - Human Resources</p>
                        <p>Signature of the employer / officer Authorized Designation.</p>
                        <p>Name & address of the establishment or Rubber stamp of thereof</p>
                    </div>
                </div>
                
                <div className='d-flex justify-content-between my-1 '>
                    <div>
                        <p>Place: <strong>{data?.commonDetails?.job_location}</strong></p>
                        <p>Date: <strong>{dateConvert(data?.employee?.joining_date, 'day-mon-year')}</strong> </p>
                    </div>
                    <div className=''>
                        {!readOnly && <RenderSignatureField
                            name="user_signature_url"
                            handleChange={handleChange}
                            value={signature}
                            handleRemove={handleRemove}
                            lable="Employee Signature"
                        />}

                    </div>
                </div>
                {
                    !readOnly && <div className='d-flex gap-2 justify-content-end position-fixed w90 bottom-0 end-0 px-4 pb-2 bg-white'>
                        <button className="btn-default" onClick={onPrev}>Previous</button>
                        <button className='btn-primary' onClick={onNext}>Proceed</button>
                    </div>
                }

                <CommanDialog visible={showPopup?.visibel} message={"Are you sure you want to delete this?"} handleClose={() => setShowPopup({
                    visibel: false,
                    section: "",
                    row: ""
                })} handleFun={() => handleDelete(showPopup?.section, showPopup?.row)} />
            </div>
        </div>
    )
}

export default GratuityNomination